<template>
  <content-loader
    class="pt-0"
    :height="22"
    :width="400"
    :speed="5"
    primaryColor="#424242"
    secondaryColor="#ecebeb">
    <rect x="4" y="7" rx="0" ry="0" width="112.42" height="4"></rect>
    <rect x="4" y="14" rx="0" ry="0" width="304" height="4"></rect>
  </content-loader>
</template>

<script>
  import { ContentLoader } from 'vue-content-loader';

  export default {
    name: 'tool-content-loader',
    components: {
      ContentLoader,
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Shared/SharedContentLoader.vue